/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import getQueryString from './getUrlQuery';
import report from './report';
import openApp from '@huyafed/openapp';

export const getShareUa = () => {
  const ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return 'wx';
  }
  if (ua.match(/WeiBo/i) == 'weibo') {
    return 'weibo';
  }
  if (ua.match(/QQ/i) == 'qq') {
    return 'qq';
  }
  return '';
};

function isiOS() {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

export default {
  validURL(str) {
    try {
      new URL(str);
    } catch (_) {
      return false;
    }
    return true;
  },
  isArd: () => navigator.userAgent.includes('Android'),
  isiOS,
  jumpGameDetail: (obj, callBack) => {
    const gamecenterauid = getQueryString('gamecenterauid') || getQueryString('gamecenterAuid') || '';
    const fromId = getQueryString('fromId') || getQueryString('fromid') || getQueryString('fromID') || 'app-gc';
    const chId = getQueryString('chId') || getQueryString('chid') || '';
    openApp({
      isForceSchemaLink: true,
      url: encodeURIComponent(`https://m.huya.com?hyaction=newrn&rnmodule=kiwi-GameCenter&rnentry=kiwi-GameCenterDetail&gameID=${obj.gameId}&hideBar=true&hideTitleBar=true&disablePopGesture=1&statusbarLiteContent=true&fromID=${fromId}&${obj.toAction ? `&toAction=${obj.toAction}` : ''}&gamecenterauid=${gamecenterauid}&chId=${chId}`),
      wechatOpenFailCallback: () => {
        callBack(true);
      },
      openFailCallback: () => {
        if (getShareUa() === 'weibo' && isiOS()) {
          callBack(true);
        }
      }
    })
  },
  getToActive: status => {
    if (status == 1) return 'download';
    if (status == 2) return 'reserve';
    return '';
  },
  // 用户/点击/优惠券/分享落地页 当在分享落地页中点击优惠券卡片时
  handleClickCouponRep: objItem => {
    const obj = {
      ...objItem,
      share_fromid: getShareUa(),
    };
    report({
      eid: 'usr/click/coupon/share-gamedetail',
      rso_desc: '用户/点击/优惠券/分享落地页',
      prop: JSON.stringify(obj),
    });
  },
  // 用户/点击/礼包卡片/分享落地页 当用户点击分享落地页中的礼品卡片
  handleClickGiftRep: objItem => {
    const obj = {
      ...objItem,
      share_fromid: getShareUa(),
    };
    report({
      eid: 'usr/click/gift-card/share-gamedetail',
      rso_desc: '用户/点击/礼包卡片/分享落地页',
      prop: JSON.stringify(obj),
    });
  },
  // 系统/曝光/分享落地页 当用户点击分享链接跳转到分享落地页时
  handleExposureRep: objItem => {
    const obj = {
      ...objItem,
      share_fromid: getShareUa(),
    };
    report({
      eid: 'sys/pageshow/share_gamedetail/gc',
      rso_desc: '系统/曝光/分享落地页',
      prop: JSON.stringify(obj),
    });
  },
  // 用户/点击/相关直播/分享落地页  当用户点击分享落地页中相关直播时
  handleClickLiveRep: objItem => {
    const obj = {
      ...objItem,
      share_fromid: getShareUa(),
    };
    report({
      eid: 'usr/click/relevantlive/share-gamedetail',
      rso_desc: '用户/点击/相关直播/分享落地页',
      prop: JSON.stringify(obj),
    });
  },
  // 用户/点击/攻略/分享落地页  点击分享落地页中主播攻略卡片时
  handleClickStrategyRep(objItem) {
    const obj = {
      ...objItem,
      share_fromid: getShareUa(),
    };
    report({
      eid: 'usr/click/strategy/share-gamedetail',
      rso_desc: '用户/点击/攻略/分享落地页',
      prop: JSON.stringify(obj),
    });
  },
  // 用户/点击/评论卡片/分享落地页  点击分享落地页中评论卡片时
  handleClickCommenteRep(objItem) {
    const obj = {
      ...objItem,
      share_fromid: getShareUa(),
    };
    report({
      eid: 'usr/click/comment/share-gamedetail',
      rso_desc: '用户/点击/评论卡片/分享落地页',
      prop: JSON.stringify(obj),
    });
  },
  // 用户/点击/按钮/分享落地页  点击分享落地页中按钮时（底部按钮）
  handleClickDownloadRep(objItem) {
    const obj = {
      ...objItem,
      share_fromid: getShareUa(),
    };
    report({
      eid: 'usr/click/button/share-gamedetail',
      rso_desc: '用户/点击/按钮/分享落地页',
      prop: JSON.stringify(obj),
    });
  },
  // 用户/点击/游戏基础信息/分享落地页   点击分享落地页中游戏基础信息内容（含游戏权
  handleClickInfoRep(objItem) {
    const obj = {
      ...objItem,
      share_fromid: getShareUa(),
    };
    report({
      eid: 'usr/click/basic-infomation/share-gamedetail',
      rso_desc: '用户/点击/游戏基础信息/分享落地页',
      prop: JSON.stringify(obj),
    });
  },
  // 用户/点击/游戏详情卡片/分享落地页   点击分享落地页中游戏详情卡片时
  handleClickDescRep(objItem) {
    const obj = {
      ...objItem,
      share_fromid: getShareUa(),
    };
    report({
      eid: 'usr/click/introduction/share-gamedetail',
      rso_desc: '用户/点击/游戏详情卡片/分享落地页',
      prop: JSON.stringify(obj),
    });
  },
};
